import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { TituloDTO } from '../../../../models/dashboard/titulo.model';

@Component({
  selector: 'app-recebimento-dialog',
  templateUrl: './recebimento-dialog.component.html',
  styleUrls: ['./recebimento-dialog.component.scss'],
})
export class RecebimentoDialogComponent implements OnChanges, OnDestroy {

  @Input() visible = false;
  @Input() titulo: TituloDTO | null = null;
  @Input() processando = false;
  @Input() tipoOperacao: 'ENTRADA' | 'SAIDA' = 'ENTRADA';

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() confirmar = new EventEmitter<{ tituloId: number; valor: number }>();

  valorRecebimento = 0;
  erroValidacao = '';

  // Traducoes
  texts = {
    titulo_recebimento: '',
    titulo_pagamento: '',
    confirmar_recebimento: '',
    confirmar_pagamento: '',
  };

  labels = {
    titulo_numero: '',
    saldo_titulo: '',
    valor_recebimento: '',
    valor_pagamento: '',
  };

  botoes = {
    cancelar: '',
    confirmar: '',
  };

  mensagens = {
    valor_invalido: '',
  };

  private langChangeSub!: Subscription;

  constructor(private translate: TranslateService) {
    this.loadTranslations();
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.loadTranslations();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['titulo'] && this.titulo) {
      this.valorRecebimento = this.titulo.saldo;
      this.erroValidacao = '';
    }
    if (changes['visible'] && !this.visible) {
      this.erroValidacao = '';
    }
  }

  ngOnDestroy(): void {
    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
  }

  get tituloDialog(): string {
    return this.tipoOperacao === 'ENTRADA'
      ? this.texts.titulo_recebimento
      : this.texts.titulo_pagamento;
  }

  get labelValor(): string {
    return this.tipoOperacao === 'ENTRADA'
      ? this.labels.valor_recebimento
      : this.labels.valor_pagamento;
  }

  fechar(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  onConfirmar(): void {
    if (!this.titulo) return;

    if (this.valorRecebimento <= 0 || this.valorRecebimento > this.titulo.saldo) {
      this.erroValidacao = this.mensagens.valor_invalido;
      return;
    }

    this.erroValidacao = '';
    this.confirmar.emit({
      tituloId: this.titulo.id,
      valor: this.valorRecebimento,
    });
  }

  private loadTranslations(): void {
    this.texts = {
      titulo_recebimento: this.translate.instant('contas-cobrar.texts.titulo_recebimento'),
      titulo_pagamento: this.translate.instant('contas-cobrar.texts.titulo_pagamento'),
      confirmar_recebimento: this.translate.instant('contas-cobrar.texts.confirmar_recebimento'),
      confirmar_pagamento: this.translate.instant('contas-cobrar.texts.confirmar_pagamento'),
    };

    this.labels = {
      titulo_numero: this.translate.instant('contas-cobrar.labels.titulo_numero'),
      saldo_titulo: this.translate.instant('contas-cobrar.labels.saldo_titulo'),
      valor_recebimento: this.translate.instant('contas-cobrar.labels.valor_recebimento'),
      valor_pagamento: this.translate.instant('contas-cobrar.labels.valor_pagamento'),
    };

    this.botoes = {
      cancelar: this.translate.instant('common.cancelar'),
      confirmar: this.translate.instant('common.confirmar'),
    };

    this.mensagens = {
      valor_invalido: this.translate.instant('contas-cobrar.mensagens.valor_invalido'),
    };
  }
}
